import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as Actions from 'actions';
import { connect } from 'react-redux';
import withContexts from 'helpers/contextsMerge'
import queryString from 'query-string';
import Breadcrumbs from '../../components/elements/Breadcrumbs.js'
import breadcrumbsConst from '../../constants/breadcrumbs.js'
import TextTabsList from './TextTabsList.js'
import TextTabsEditor from './TextTabsEditor.js'
import GeneralError from '../../components/errors/GeneralError.js';
import Loading from '../../components/Loading.js';

class TextsTabs extends Component {
	constructor(props) {
		super(props);

		this.state = { brElem: null, id: null, type: '' };
	}

	static getDerivedStateFromProps(props, state) {
		const cPath = props.pathcontext.currentPath;
		const cQuery = props.pathcontext.query;

		const isDifPath = cPath !== state.brElem;
		const isDifType = cPath.replace('/', '') !== state.type;
		const queryId = queryString.parse(cQuery).id;
		const isDifId = queryId !== state.id || !state.id;

		if (isDifPath || isDifType || isDifId) {
			return {
				brElem: breadcrumbsConst.filter(br => br.path.startsWith(cPath))[0],
				type: cPath.replace('/', ''),
				id: isDifType ? '1' : queryId || '1'
			};
		}

		return null;
	}

	componentDidMount() {
		const { actions } = this.props;
		const { brElem, type, id } = this.state;

		if (brElem) actions.setBreadCrumbs(brElem.list)

		if (type && id) {
			actions.loadTabs(type, id);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { actions, langContext: {
			currentLang
		} } = this.props;
		const { brElem, type, id } = this.state;

		if (brElem && brElem !== prevState.brElem) {
			actions.setBreadCrumbs(brElem.list);
		}

		if (type !== prevState.type || id !== prevState.id || currentLang !== prevProps.langContext.currentLang) {
			actions.loadTabs(type, id || 1);
		}
	}

	componentWillUnmount() {
		const { actions } = this.props;
		actions.resetBreadCrumbs();
	}

	submitTabText = (text) => {
		const { actions } = this.props;
		const { type, id } = this.state;

		actions.saveTabText(text, id, type);
	}

	addImage = (file) => {
		const { actions } = this.props;

		actions.convertImage(file);
	}

	resetAddImage = () => {
		const { actions } = this.props;

		actions.resetAddImage();
	}

	render() {
		const { tabs, tabData, user, langContext: { dict }, breadCrumbs, error, isPageError, err, imageTab, insertImage } = this.props;
		const { type, id } = this.state;
		const isAllowed = !!localStorage.getItem('user') && user && user.role && (user.role.code === 'admin' || user.role.code === 'editor');

		if (isPageError) {
			return <GeneralError errMsg={err.message} />;
		}

		if (!type || !dict[`breadcrumbs.${type}`]) {
			return <Loading />;
		}

		return (
			<div className="page--alt text-tabs">
				<div className={`page__top`}>
					<Breadcrumbs breadCrumbsList={breadCrumbs} dict={dict}/>
					<div className="page__header">
						{dict[`breadcrumbs.${type}`].toUpperCase()}
					</div>
					<div className="text-tabs__tabs">
						<TextTabsList tabs={tabs} type={type} id={id} />
					</div>
				</div>
				<div className={`page__content`}>
					<div className="page__content__inner page__content--scrollable">
						<div className="text-tabs__content">
							<TextTabsEditor
								isAllowed={isAllowed}
								submitTabText={this.submitTabText}
								tabData={tabData}
								addImage={this.addImage}
								resetAddImage={this.resetAddImage}
								imageTab={imageTab}
								error={error}
								insertImage={insertImage}
								dict={dict}
								type={type}
								id={id}
								/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

TextsTabs.propTypes = {
	isPageError: PropTypes.bool.isRequired,
	tabs: PropTypes.arrayOf(PropTypes.shape({
		index: PropTypes.number.isRequired,
		type: PropTypes.string,
		title: PropTypes.string,
	})),
	breadCrumbs: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		link: PropTypes.string,
	})),
	error: PropTypes.string,
	imageTab: PropTypes.string,
	insertImage: PropTypes.bool,
	err: PropTypes.shape({}),
};

const mapStateToProps = state => ({
	tabs: state.textTabs.tabs,
	tabData: state.textTabs.tabData,
	breadCrumbs: state.page.breadCrumbs,
	error: state.textTabs.error,
	isPageError: state.page.isPageError,
	err: state.page.pageErr,
	imageTab: state.textTabs.imageTab,
	insertImage: state.textTabs.insertImage,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});

export default withContexts(connect(mapStateToProps, mapDispatchToProps)(TextsTabs));
